import { render, staticRenderFns } from "./ReligionFilter.vue?vue&type=template&id=a21a46ea&"
import script from "./ReligionFilter.vue?vue&type=script&lang=js&"
export * from "./ReligionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports